import { PaletteBanner as Banner } from '@ulta/core/adapters/palette/components/PaletteBanner/PaletteBanner';

export default Banner;